module.exports = __webpack_public_path__ + "static/media/logo-footer.1b612115.png";